import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview, captureUtm } from "@/lib/tracking";

const EXCLUDED_PATHS = ["/dashboard"];

/** Trackt jeden Routenwechsel anonym — außer Admin-/Dashboard-Pfade. */
export function usePageTracking() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    if (EXCLUDED_PATHS.some((p) => path === p || path.startsWith(p + "/"))) return;
    captureUtm();
    trackPageview(path + location.search);
  }, [location.pathname, location.search]);
}
